/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { Notify } from "notiflix/build/notiflix-notify-aio";
import { Confirm } from "notiflix/build/notiflix-confirm-aio";

import { styled } from "@mui/material/styles";

import moment from "moment";

import { Loading } from "notiflix/build/notiflix-loading-aio";
import { Block } from "notiflix/build/notiflix-block-aio";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";

import TextField from "@mui/material/TextField";

import Box from "@mui/material/Box";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { AddBox } from "@mui/icons-material";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Typography from "@mui/material/Typography";

import ControlledTextInput from "components/FormInputs/ControlledTextInput";
import ControlledDateTime from "components/FormInputs/ControlledDateTime";
import ControlledCheckbox from "components/FormInputs/ControlledCheckbox";
import ControlledSelect from "components/FormInputs/ControlledSelect";
import CustomInputs from "components/CustomInputs";
import { CustomSelect } from "components/CustomSelect";

//components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import Check from "@mui/icons-material/Check";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from '@mui/material/FormControlLabel';

import Tooltip from "@mui/material/Tooltip";

import Edit from "@mui/icons-material/Edit";
import Close from "@mui/icons-material/Close";
import SettingsIcon from '@mui/icons-material/Settings';

import InputAdornment from "@mui/material/InputAdornment";

import Alert from "components/CustomAlert";

import ViewReminder from './view'

import { tables, dateFormat } from "utils/constants";

// rtk queries
import {
  useGetAllReminderTypesQuery,
  useGetAllUpcomingRemindersQuery,
  useLazyGetAllReminderTypesQuery,
  useDeleteReminderTypeMutation
} from "services/reminders";

import { globalCountry } from "store/entities/countries";

import { useDispatch, useSelector } from "react-redux";

import { replaceHTMLEntityAnd } from "utils/helperFunctions";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function UpcomingReminders () {

  const selectedCountry = useSelector(globalCountry);

  const { data: reminderTypes, isLoading: isReminderTypesLoading, isSuccess: isReminderTypesSuccess } = useGetAllReminderTypesQuery();

  const { data: upcomingReminders = [], isLoading, isSuccess } = useGetAllUpcomingRemindersQuery();

  // const [deleteReminderType] = useDeleteReminderTypeMutation();

  const dispatch = useDispatch();

  useEffect(() => {
    Loading.dots({
      svgColor: "rgba(159, 3, 3, 0.8)",
    });

    isSuccess && isReminderTypesSuccess && Loading.remove(500);
  }, [isSuccess, isReminderTypesSuccess]);

  return (
    <Card>
      <CardHeader
        // avatar={<AccountCircleIcon fontSize="large" color="info" />}
        title={<MDTypography color="info">Upcoming Reminders</MDTypography>}
      />
      <CardContent>
        <br />
        {/* {BDMList && BDMList.length > 0 ? ( */}
          <DataTable
            // headerActions={
            //   <FormControlLabel control={
            //     <Checkbox
            //     checkedIcon={<Check />}
            //     icon={<Check />}
            //     onChange={(e) => setWithOldRecords(e.target.checked)}
            //     checked={withOldRecords}
            //   />
            //   } label="Including inactive" />
            // }
            columns={[
              { 
                Header: "company", 
                accessor: "company_name",
              },
              { 
                Header: "product", 
                accessor: "product_name"
              },
              { 
                Header: "to", 
                accessor: "to"
              },
              { 
                Header: "Type", 
                accessor: "custom_reminder_id",
                // Cell: ({ row: { original } }) => {selectedCountry.currency + original.total_sales.toFixed(2)}
                Cell: ({ row: { original } }) => original.custom_reminder_id ? <MDBadge badgeContent="Custom" color="success" variant="gradient" size="sm" /> : original.end_user_id ? <MDBadge badgeContent="End-User reminder" color="info" variant="gradient" size="sm" /> : <MDBadge badgeContent="Class A" color="primary" variant="gradient" size="sm" />
              },
              {
                Header: "Expiry Date",
                accessor: "expiry_date",
                Cell: ({ row: { original } }) => moment(original.expiry_date).format(dateFormat),
              },
              {
                Header: "action",
                accessor: "action",
                align: "right",
                disableSortBy: true,
                disableFilters: true,
                show: true,
                // eslint-disable-next-line react/display-name
                Cell: ({ row: { original } }) => (
                  <div className="actions-right">
                    <ViewReminder data={original} reminderTypes={reminderTypes} country={selectedCountry} />
                  </div>
                ),
              },
            ]}
            data={upcomingReminders.filter(reminder => reminder.country_id == selectedCountry.id || reminder.country_id == 0)}
            isSorted={true}
            entriesPerPage={false}
            showTotalEntries={false}
            hideColumnSelection={false}
            noEndBorder
            canSearch
            // actionButton={
            //   <AddReminderType />
            // }
          />
        {/* ) : (
          <Alert severity="warning">No Business Developement Managers found!</Alert>
        )} */}
      </CardContent>
    </Card>
  );
}

export default UpcomingReminders;
